import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Tooltip, Typography } from "antd";
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  removeTimelineAction,
  setDraftDialogAdvanceSelected,
  setDraftDialogAdvanceUndo,
  setDraftDialogEditorEdit,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import { draftDialogAdvanceSelected } from "store/bailiff/draft/dialog/draft_dialog.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const COLOR = {
  speaker0: "#FF6B6B", // Đỏ San Hô (Màu hiện tại của bạn)
  speaker1: "#4ECDC4", // Xanh Ngọc
  speaker2: "#45AAF2", // Xanh Dương Sáng
  speaker3: "#FED330", // Vàng Hướng Dương
  speaker4: "#A55EE1", // Tím Lavender
  speaker5: "#26DE81", // Xanh Lá Mạ
  speaker6: "#FD9644", // Cam Nhạt
  speaker7: "#EB3B5A", // Hồng Crimson
  speaker8: "#2BCBBA", // Xanh Bọt Biển
  speaker9: "#778CA3", // Xám Xanh (Muted)
};

export const TEXT_COLOR = {
  speaker0: "#FFFFFF", // Trắng (trên nền Đỏ)
  speaker1: "#121212", // Đen đậm (trên nền Xanh ngọc sáng)
  speaker2: "#FFFFFF", // Trắng (trên nền Xanh dương)
  speaker3: "#121212", // Đen đậm (trên nền Vàng sáng)
  speaker4: "#FFFFFF", // Trắng (trên nền Tím)
  speaker5: "#121212", // Đen đậm (trên nền Xanh lá mạ)
  speaker6: "#121212", // Đen đậm (trên nền Cam nhạt)
  speaker7: "#FFFFFF", // Trắng (trên nền Hồng đậm)
  speaker8: "#FFFFFF", // Trắng (trên nền Xanh lá mạ)
  speaker9: "#121212", // Đen đậm (trên nền Xanh bọt biển)
  speaker10: "#FFFFFF", // Trắng (trên nền Xám xanh)
};

const ColorBlock = ({ action, id, actionId, editor }) => {
  // -------------------------- VAR -----------------------------
  const content = action?.content || "";
  const speaker = action?.speaker || "speaker1";
  const color = action?.bgColor || COLOR[speaker];
  const textColor = action?.color || TEXT_COLOR[speaker];

  // -------------------------- STATE ---------------------------

  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const advanceSelected = useSelector(draftDialogAdvanceSelected);
  const chosen = advanceSelected === id;
  const classBg = chosen ? "border-[3px] border-green-500" : "";
  // -------------------------- FUNCTION ------------------------
  const handleRemoveAction = useCallback(() => {
    if (!editor) return;
    dispatch(setDraftDialogAdvanceUndo(editor));
    dispatch(removeTimelineAction({ origin: editor, id, actionId }));
  }, [actionId, dispatch, editor, id]);

  const handleSelect = () => {
    const data = { origin: editor, id, action };
    dispatch(setDraftDialogEditorEdit(data));
  };

  const handleClick = () => {
    dispatch(setDraftDialogAdvanceSelected(id));
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderEdit = () => {
    return (
      <Tooltip title="Sửa đoạn này">
        <Button
          onClick={handleSelect}
          type="text"
          icon={<EditOutlined style={{ color: textColor }} />}
        />
      </Tooltip>
    );
  };

  const renderRemove = () => {
    return (
      <Tooltip title="Xoá đoạn này">
        <Button
          onClick={handleRemoveAction}
          type="text"
          icon={<CloseOutlined style={{ color: textColor }} />}
        />
      </Tooltip>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: color, // Màu đỏ nhạt
        color: textColor,
        fontSize: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // border: "0.5px solid #fff",
        borderRadius: "6px",
        overflow: "hidden",
        cursor: "grab",
      }}
      className={`px-1 ${classBg}`}
    >
      {renderEdit()}

      <Typography.Text
        onClick={handleClick}
        style={{ color: textColor, width: "99%" }}
        ellipsis={{ rows: 1 }}
      >
        {content}
      </Typography.Text>
      {renderRemove()}
    </div>
  );
};
export default ColorBlock;
